import { unsafeCSS, html } from "lit";
import { BaseValueProp } from "../../base/value-prop/value-prop.js";
import "lit/decorators.js";
import "../../components/leaf-element.js";
import "../../utilities/events.js";
import "../../utilities/slot.js";
import "../../components/icon/icon.js";
import "../../components/icon/icon.component.js";
import "lit/directives/unsafe-svg.js";
import "../../utilities/cache-fetch.js";
import "../../utilities/watch.js";
import "../../components/icon/library.js";
import "../../components/icon/iconset.system.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  --leafdcws-value-prop-icon-height: 100px;\n  --leafdcws-value-prop-icon-width: 100px;\n}\n\n.tcg-c-value-prop .base-c-value-prop--icon-container {\n  margin: var(--leaf-spacing-18);\n}\n.tcg-c-value-prop .base-c-value-prop--heading ::slotted([slot=meta]) {\n  margin: 0;\n}\n\n.tcg-c-value-prop--center {\n  align-items: center;\n}";
class TCGValueProp extends BaseValueProp {
  render() {
    return html`<div class="tcg-c-value-prop">${super.render()}</div>`;
  }
}
TCGValueProp.styles = unsafeCSS([BaseValueProp.styles, styles]);
export {
  TCGValueProp
};
//# sourceMappingURL=value-prop.component.js.map
